var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.character
    ? _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "page-header" },
          [
            _c("h1", { staticClass: "page-title" }, [
              _vm._v("Character Details"),
            ]),
            _c("breadcrumb", {
              attrs: {
                name: "ADVOCACY_CHARACTER_DETAIL",
                withLast: _vm.breadcrumbTitle,
              },
              on: {
                "update:withLast": function ($event) {
                  _vm.breadcrumbTitle = $event
                },
                "update:with-last": function ($event) {
                  _vm.breadcrumbTitle = $event
                },
              },
            }),
            _c("div", { staticClass: "page-header-actions detail-actions" }, [
              _c(
                "span",
                { staticClass: "save-badge", class: _vm.saveStateClass },
                [_vm._v(" " + _vm._s(_vm.saveStateText) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-round btn-default",
                  attrs: { type: "button" },
                  on: { click: _vm.goBack },
                },
                [
                  _c("i", {
                    staticClass: "icon md-chevron-left",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" Back to list "),
                ]
              ),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "page-content container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xl-12 col-lg-12" }, [
              _c("div", { staticClass: "panel panel-bordered mb-30" }, [
                _c("div", { staticClass: "panel-heading" }, [
                  _c("h3", { staticClass: "panel-title" }, [
                    _vm._v("Character - " + _vm._s(_vm.character.id)),
                  ]),
                ]),
                _c("div", { staticClass: "panel-body" }, [
                  _c("div", { staticClass: "form-horizontal" }, [
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-sm-2 col-form-label" }, [
                        _vm._v("Character ID"),
                      ]),
                      _c("div", { staticClass: "col-sm-6 detail-value" }, [
                        _vm._v(_vm._s(_vm.character.id)),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-sm-2 col-form-label" }, [
                        _vm._v("Character Name"),
                      ]),
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.name,
                              expression: "form.name",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", maxlength: "255" },
                          domProps: { value: _vm.form.name },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.form, "name", $event.target.value)
                              },
                              _vm.onFormInput,
                            ],
                            blur: _vm.onFormBlur,
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-group row mb-0" }, [
                      _c("label", { staticClass: "col-sm-2 col-form-label" }, [
                        _vm._v("Description"),
                      ]),
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.description,
                              expression: "form.description",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { rows: "3", maxlength: "255" },
                          domProps: { value: _vm.form.description },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "description",
                                  $event.target.value
                                )
                              },
                              _vm.onFormInput,
                            ],
                            blur: _vm.onFormBlur,
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "autosave-note" }, [
                    _vm._v(" Auto save when leaving a text field. "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "panel panel-bordered mb-30" }, [
                _vm._m(0),
                _c("div", { staticClass: "panel-body" }, [
                  _c("div", { staticClass: "upload-card" }, [
                    _c("div", { staticClass: "upload-card-header" }, [
                      _vm._m(1),
                      _vm.uploadingField === "background_url"
                        ? _c("span", { staticClass: "uploading-text" }, [
                            _vm._v(" Uploading... "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "upload-preview-wrapper" }, [
                      _vm.character.background_url
                        ? _c("img", {
                            staticClass: "upload-preview",
                            attrs: {
                              src: _vm.character.background_url,
                              alt: "Background preview",
                            },
                          })
                        : _c("div", { staticClass: "preview-placeholder" }, [
                            _vm._v("No image uploaded"),
                          ]),
                    ]),
                    _c("div", { staticClass: "file-input-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-sm",
                          attrs: {
                            type: "button",
                            disabled: _vm.uploadingField === "background_url",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openFilePicker("background_url")
                            },
                          },
                        },
                        [_vm._v(" Choose file ")]
                      ),
                      _c("span", { staticClass: "file-input-name" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.selectedFileNames.background_url ||
                                "No file chosen"
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("input", {
                      ref: "background_url",
                      staticClass: "file-input-native",
                      attrs: {
                        type: "file",
                        accept: ".png,image/png",
                        disabled: _vm.uploadingField === "background_url",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.uploadImage(
                            "background_url",
                            "Background Image",
                            $event
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "panel panel-bordered" }, [
                _vm._m(2),
                _c("div", { staticClass: "panel-body" }, [
                  _c(
                    "div",
                    { staticClass: "slot-grid" },
                    _vm._l(_vm.animationSlots, function (slot) {
                      return _c(
                        "div",
                        { key: slot.number, staticClass: "upload-card" },
                        [
                          _c("div", { staticClass: "upload-card-header" }, [
                            _c("div", [
                              _c("h5", { staticClass: "mb-5" }, [
                                _vm._v("Slot " + _vm._s(slot.number)),
                              ]),
                              _c("p", { staticClass: "upload-helper mb-0" }, [
                                _vm._v(
                                  " Field " +
                                    _vm._s(slot.field) +
                                    " · PNG only · 1869 x 3005 pixels "
                                ),
                              ]),
                            ]),
                            _vm.uploadingField === slot.field
                              ? _c("span", { staticClass: "uploading-text" }, [
                                  _vm._v(" Uploading... "),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "upload-preview-wrapper" }, [
                            slot.image_url
                              ? _c("img", {
                                  staticClass: "upload-preview",
                                  attrs: {
                                    src: slot.image_url,
                                    alt: "Character slot " + slot.number,
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "preview-placeholder" },
                                  [_vm._v("No image uploaded")]
                                ),
                          ]),
                          _c("div", { staticClass: "file-input-row" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default btn-sm",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.uploadingField === slot.field,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openFilePicker(slot.field)
                                  },
                                },
                              },
                              [_vm._v(" Choose file ")]
                            ),
                            _c("span", { staticClass: "file-input-name" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.selectedFileNames[slot.field] ||
                                      "No file chosen"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("input", {
                            ref: slot.field,
                            refInFor: true,
                            staticClass: "file-input-native",
                            attrs: {
                              type: "file",
                              accept: ".png,image/png",
                              disabled: _vm.uploadingField === slot.field,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.uploadImage(
                                  slot.field,
                                  "Slot " + slot.number,
                                  $event
                                )
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [_vm._v("Background Image")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", { staticClass: "mb-5" }, [_vm._v("Background Image")]),
      _c("p", { staticClass: "upload-helper mb-0" }, [
        _vm._v(" PNG only. Recommended size 1869 x 3005 pixels. "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [_vm._v("Character Images")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }